import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { getIsGlobalUser } from '../../../features/loginSystem/selectors';

const GlobalReviewCommentContent = ({ state = {}, setState }) => {
  const isGlobalUser = useSelector(getIsGlobalUser);
  const { formatMessage } = useIntl();
  const reviewCommentHasError = !!state.reviewCommentHasError;

  const value = _.get(state, `globalReviewComment`, '');

  const error = (reviewCommentHasError && !value) || value.length > 500;

  const errorText =
    error && value.length < 500
      ? formatMessage({
          id: 'prompt.contentReviewCommentMissingDataError'
        })
      : '';

  const label = formatMessage({
    id: 'prompt.contentReviewCommentTextFieldLabel'
  });
  return (
    <>
      <Typography variant="body1">
        <FormattedMessage id="prompt.contentReviewCommentText" />
      </Typography>
      <TextField
        id="filled-multiline-static"
        label={label}
        multiline
        required
        fullWidth
        rows="3"
        variant="filled"
        value={value}
        error={error}
        helperText={errorText}
        onChange={event => {
          setState({
            globalReviewComment: event.target.value
          });
        }}
        style={{ marginTop: '1em' }}
        key="review-comment"
      />
      <p
        style={{
          textAlign: 'right',
          marginTop: '0px',
          ...(value.length > 500 ? { color: '#E00751' } : '')
        }}
      >
        {value.length}/500
      </p>
      <p style={{ marginBottom: 0 }}>
        <Typography variant="caption">
          <FormattedMessage id="prompt.contentReviewCommentNoteGlobalUser" />
        </Typography>
      </p>
    </>
  );
};

const transformReviewDataToApiFormat = (promptState = {}) => {
  let approvalData = {};
  _.forOwn(promptState.globalReviewComment, () => {
    approvalData = {
      ...approvalData,
      globalReviewComment: promptState.globalReviewComment
    };
  });
  return approvalData;
};

export default GlobalReviewCommentContent;
export { transformReviewDataToApiFormat };
